import { SvgTypesProps } from '@/shared/types/SvgTypes';

export function IconPhone({
  fill = 'var(--accent-310)',
  width = 15,
  height = 15,
}: SvgTypesProps) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      overflow='visible'
    >
      <path
        d="M4.287 12.112c3.094 3.094 7.213 4.233 10.248 3.118 1.349-.496 1.42-2.195.5-3.299l-.77-.922a1.68 1.68 0 0 0-2.478-.111c-.494.494-1.244.632-1.86.303-.864-.46-2.066-1.172-2.811-1.917-.745-.745-1.457-1.948-1.917-2.81-.329-.618-.192-1.367.303-1.862a1.68 1.68 0 0 0-.111-2.477l-.922-.77c-1.104-.921-2.803-.85-3.3.5C.055 4.9 1.195 9.019 4.288 12.112Z"
        stroke={fill}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}